"use strict";

exports.__esModule = true;
exports.DefaultLayout = void 0;
var _types = require("../types");
const DefaultLayout = exports.DefaultLayout = {
  resizeDirection: _types.ResizeDirection.horizontalAndVertical,
  contentResizeDirection: _types.ContentResizeDirection.horizontalAndVertical,
  disableStretching: false,
  disablePositioning: false,
  disableRotation: false
};
//# sourceMappingURL=layout.js.map